<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<el-form-item label="预约人">
				<el-input v-model="form.username" placeholder="预约人" clearable=""></el-input>
			</el-form-item>
			<el-form-item label="联系方式">
				<el-input v-model="form.phone" placeholder="联系方式" clearable=""></el-input>
			</el-form-item>
			<el-form-item label="提交时间">
				<el-date-picker v-model="form.createTimeStart" type="datetime" placeholder="录入开始时间">
				</el-date-picker>
				<span>-</span>
				<el-date-picker v-model="form.createTimeEnd" type="datetime" placeholder="录入结束时间">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="审核状态">
				<el-select v-model="form.status" placeholder="审核状态" clearable="clearable">
					<el-option label="未审批" value="未审批"></el-option>
					<el-option label="已同意" value="已同意"></el-option>
					<el-option label="已拒绝" value="已拒绝"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getAll()">查询</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="name" label="提交人"></el-table-column>
			<el-table-column prop="phone" label="联系电话"></el-table-column>
			<el-table-column prop="number" label="预约会议室"></el-table-column>
			<el-table-column prop="startTime" label="开始使用时间">
				<template slot-scope="{row}">{{setTime(row.startTime)}}</template>
			</el-table-column>
			<el-table-column prop="endTime" label="结束使用时间">
				<template slot-scope="{row}">{{setTime(row.endTime)}}</template>
			</el-table-column>
			<el-table-column prop="hours" label="用时(小时)"></el-table-column>
			<el-table-column prop="createTime" label="提交时间">
				<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
			</el-table-column>
			<el-table-column prop="status" label="审核状态"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum">
		</el-pagination>
		<el-dialog title="详情" :visible.sync="isShow" width="30%">
			<el-form :model="row">
				<el-col :span="12">
					<span>提交人 ：</span>
					<span>{{row.name}}</span>
				</el-col>
				<el-col :span="12">
					<span>联系方式 ：</span>
					<span>{{row.phone}}</span>
				</el-col>
				<el-col :span="12">
					<span>提交时间 ：</span>
					<span>{{setTime(row.createTime)}}</span>
				</el-col>
				<el-col :span="12">
					<span>预约会议室 ：</span>
					<span>{{row.number}}</span>
				</el-col>
				<el-col :span="12">
					<span>使用时间 ：</span>
					<span>{{setTime(row.startTime)}}</span>
				</el-col>
				<el-col :span="12">
					<span>结束时间 ：</span>
					<span>{{setTime(row.endTime)}}</span>
				</el-col>
				<el-col :span="12">
					<span>用时(小时) ：</span>
					<span>{{row.hours}}</span>
				</el-col>
				<el-col :span="12">
					<span>预约说明 ：</span>
					<span>{{row.reason}}</span>
				</el-col>
				<el-col style="margin-top: 20px;" :span="24">
					<span style="font-size: 25px;">审核</span>
				</el-col>
				<div v-if="row.result=='未完成'&&row.status=='未审批'">
					<el-radio v-model="radio" label="1">同意</el-radio>
					<el-radio v-model="radio" label="2">拒绝</el-radio>
					<el-input v-if="radio=='2'" v-model="reason" placeholder="请输入拒绝原因"></el-input>
				</div>
				<div v-if="row.result=='未完成'&&row.status!='未审批'">
					<div>审核结果：{{row.status}}</div>
				</div>
				<div v-if="row.result=='已完成'">
					<div>审核结果：{{row.status}}</div>
					<div v-if="row.status=='已拒绝'">{{row.reason}}</div>
				</div>
				<div v-if="row.result=='已过期'">
					<div style="color: red;">审核时间已过！</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isShow=false">取 消</el-button>
				<el-button type="primary" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				radio:'1',
				reason:null,
				form: {
					username:null,
					phone:null,
					createTimeStart:null,
					createTimeEnd:null,
					status:null
				},
				status:null,
				data: [],
				totalNum: null,
				isShow: false,
				row: {

				}
			}
		},
		methods: {
			confirmClick(){
				if(this.radio=='1'){
					this.status='已同意'
				}else{
					this.status='已拒绝'
				}
				this.$http.post("/api/bdMeetingApply/approvalMeetingApply",{
					status:this.status,
					id:this.row.id,
					reason:this.reason
				}).then(res=>{
					if(res.data.code==0){
						this.$message.success(res.data.message)
						this.isShow=false
						this.getAll()
					}
					console.log(res)
				})
			},
			getRow(val) {
				console.log(val)
				this.isShow = true
				this.row = {
					...val
				}
			},
			handleCurrentChange(val) {
				this.form.currentPage = val
				this.getAll()
			},
			handleSizeChange(val) {
				this.form.pageSize = val
				this.getAll()
			},
			getAll() {
				this.$http.post(`/api/bdMeetingApply/queryWebMeetingApply`, this.form).then(r => {
					if (r.data.data != null) {
						this.data = r.data.data.items
						this.totalNum = r.data.data.totalNum
					} else {
						this.data = null
						this.totalNum = 0
					}

				})
			},
		},
		mounted() {
			this.getAll()

		}
	}
</script>

<style scoped="scoped">
</style>
